import React from 'react'
import PageLoading from '../../../../components/UI/status/loading'
import { ThreadsItem } from './threadsItem'
import { extractDocumentsFromText } from '../../../../utils'

export const ThreadsSection = ({ loading, list, containerRef, setShowParentThreads, fetchThreadMessages, setSelectedThread,
    receipt, onClickViewThread, selectedThreadRef, isPinnedMessagesSection = false, showParentThreadsRef, userAvatars }) => {
    const onClickShowThread = (msg) => {
        if (isPinnedMessagesSection) return
        onClickViewThread(msg)
        setSelectedThread(msg)
        selectedThreadRef.current = msg
        fetchThreadMessages(msg._id)
    }

    const hideThreadsSection = () => {
        showParentThreadsRef.current = false
        setShowParentThreads(false)
    }

    return (
        <>
            <div className='channel-heding'>
                <div>{isPinnedMessagesSection ? 'Pinned Messages' : 'All Threads'}</div>
                <div className='cursor-pointer' onClick={hideThreadsSection}>x</div>
            </div>
            {loading ? (
                <div className='loadingStyle'>
                    <PageLoading />
                </div>) : (
                <div className="threads-section-container messageStyle">
                    {list.map((msg) => {
                        let text = msg.msg
                        const { documents, text: cleanedText } = extractDocumentsFromText(text)
                        const isNewFormat = cleanedText !== text
                        text = cleanedText
                        if (msg.mentions) msg.mentions.forEach((mention) => {
                            text = text.replaceAll(`@${mention.username}`,
                                `<span class='mention'>@${mention.name}</span>`
                            )
                        })
                        const user = userAvatars.filter((user) => user.username === msg.u.username)[0]
                        const item = {
                            sender_person: msg.u.name || msg.u.username,
                            id: '',
                            created_at: msg.ts,
                            text: text,
                            status: '',
                            is_draft: '',
                            clientId: '',
                            img: user ? user.avatar : ''
                        }
                        return <ThreadsItem
                            msg={msg}
                            item={item}
                            receipt={receipt}
                            onClickItem={onClickShowThread}
                            isPinnedMessagesSection={isPinnedMessagesSection}
                            documents={documents}
                            explanation={isNewFormat ? text : undefined}
                        />
                    })}
                </div>)}
        </>
    )
}
